import { Component, OnInit, ViewChild } from '@angular/core';
import { ActionSheetController, ModalController, MenuController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import * as SFS2X from "sfs2x-api";
import { AppComponent } from 'src/app/app.component';
import { MsgTypes } from 'src/app/models/Msgtypes';
import { TimelineService } from 'src/app/services/timeline.service';
import { ZoneDataManagerService } from 'src/app/services/zone-data-manager.service';
import { RozaWiatrowPage } from '../roza-wiatrow/roza-wiatrow.page';
import { TravelPage } from '../travel/travel.page';
import { AccountPage } from '../account/account.page';
import { AccountsListPage } from '../accounts-list/accounts-list.page';


declare var Phaser;


@Component({
  selector: 'app-location',
  templateUrl: './location.page.html',
  styleUrls: ['./location.page.scss'],
})
export class LocationPage implements OnInit {

  @ViewChild('content') private content: any;
  
  
  chatId: any;
  text: string = '';
  
  odbiorcaAccount: any;
  peopleInTheRoom = [];
  modal;

  nadawcaID:string;
  odbiorcaID:string;

  observableChat: Subscription;

  akcja:string;
  juzWidzial:boolean;

  playersInRoom=0;

  shouldRateNow:boolean;


  
  constructor(public menu: MenuController, public zoneDataManager:ZoneDataManagerService,public modalController: ModalController, public timelineService:TimelineService, public actionSheetController: ActionSheetController, public app:AppComponent) { }

  ngOnInit() {
    
    this.timelineService.locationPage = this;


    

    if(!this.app.isSFSconnected) 
    {
      this.presentActionSheet();
    }
  }


  async presentTravel(chosenLocation) {
    this.modal = await this.modalController.create({
      component: TravelPage,
      cssClass: 'my-custom-class',
      backdropDismiss: false
    });
    return await this.modal.present();
  }

  async presentModal() {
    this.modal = await this.modalController.create({
      component: RozaWiatrowPage,
      cssClass: 'my-custom-class'
    });
    return await this.modal.present();
  }

  async presentAccountsModal() {

    this.timelineService.roomersList = [];

    for (let index = 0; index < this.app.room.getUserList().length; index++) {
      const element = this.app.room.getUserList()[index];
      if(!element.isItMe)
      {
        console.log('-kolo ', element);
        this.timelineService.roomersList.push(element)
      }
    }


    this.modal = await this.modalController.create({
      component: AccountsListPage
      
    });
    return await this.modal.present();
  }


  async presentAccountModal() {
    this.modal = await this.modalController.create({
      component: AccountPage,
      cssClass: 'my-custom-class'
    });
    return await this.modal.present();
  }

  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Czy chcesz wejść do Enclavii?',
      cssClass: 'my-custom-class',
      buttons: [{
        text: 'Otwórz wrota',
        icon: 'heart',
        handler: () => {
          console.log('clicked');
          this.menu.enable(true);
          this.populate()
        }
      }, {
        text: 'Odejdź sobie',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    
    await actionSheet.present();
  }


  async presentAllOptions() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Wszystkie akcje lokacji',
      cssClass: 'my-custom-class',
      buttons: [{
        text: 'Rozejrzyj się po lokacji',
        icon: 'eye-sharp',
        handler: () => {
          console.log('Rozejrzyj', this.app.room);
          this.showDescription()
          //this.populate()
        }
      }, {
        text: 'Idź do kolejnej lokacji',
        icon: 'walk',
        handler: () => {
          console.log('Idź');
          this.showDirections()
          //this.populate()
        }
      }, {
        text: 'Przeszukaj lokację',
        icon: 'search',
        handler: () => {
          console.log('Przeszukaj');
          //this.populate()
        }
      }, {
        text: 'Podnieś z ziemi',
        icon: 'bag-check-outline',
        handler: () => {
          console.log('Podnieś');
          //this.populate()
        }
      }, {
        text: 'Ukryj...',
        icon: 'ellipse-outline',
        handler: () => {
          console.log('Ukryj');
          //this.populate()
        }
      }, {
        text: 'Krzyknij!',
        icon: 'volume-high',
        handler: () => {
          console.log('Krzyknij');
          //this.populate()
        }
      }, {
        text: 'Cancel',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    
    await actionSheet.present();
  }


  sendMessage()
  {
    if(this.text.length>1) this.app.sendMessage(this.text)
    else {
      var params = new SFS2X.SFSObject();
      params.putInt("a", 25);
      params.putInt("b", 17);
 
      this.app.sfs.send( new SFS2X.ExtensionRequest("sum", params) );
      this.app.sfs.addEventListener(SFS2X.SFSEvent.EXTENSION_RESPONSE, this.onExtensionResponse, this);
      this.app.sfs.addEventListener(SFS2X.SFSEvent.USER_COUNT_CHANGE, this.onUserCountChange, this);
      this.app.sfs.addEventListener(SFS2X.SFSEvent.USER_EXIT_ROOM, this.onUserExitRoom, this);
      this.app.sfs.addEventListener(SFS2X.SFSEvent.USER_ENTER_ROOM, this.onUserEnterRoom, this);


    }
    this.text = ""
  }

  onExtensionResponse(evtParams) 
  {
      console.log("sum Result: " + evtParams.params.getInt("res"));
  }

  pickUp()
  {
    console.log("pickUp"); 
  }

  showDescription()
  {
    let opis:string = this.zoneDataManager.actualRoomName + "_DESC";

    let msg1 = {
      userId: this.timelineService.myName,
      text: opis,
      type: MsgTypes.LOCATION,
      payload: null
    }

     this.timelineService.addChatMSG(msg1)

     if(this.app.room.userCount==1)
     {
      opis = "Lokacja jest pusta";
     }
     else if(this.app.room.userCount>1 && this.app.room.userCount<5)
     {
      opis = (this.app.room.userCount -1) + " osoby w tej lokacji";
     }
     else
     {
      opis = "W lokacji jest obecnie " + (this.app.room.userCount-1) + " osób";
     }
     

     let msg2 = {
      userId: this.timelineService.myName,
      text: opis,
      type: MsgTypes.PLAYERS,
      payload: null
    }

     this.timelineService.addChatMSG(msg2)

     opis = "Mozliwe drogi: \n"

   

     console.log('----- getLocationByID', this.zoneDataManager.actualRoomName, this.zoneDataManager.currentLocation);
     
     if(this.zoneDataManager.currentLocation.n && this.zoneDataManager.currentLocation.n!="") 
     {
       opis = opis + " N | \n";
     }

     if(this.zoneDataManager.currentLocation.ne && this.zoneDataManager.currentLocation.ne!="")
     {
       opis = opis + " NE |\n";
     }

     if(this.zoneDataManager.currentLocation.e && this.zoneDataManager.currentLocation.e!="")
     {
       opis = opis + " E | \n";
     }

     if(this.zoneDataManager.currentLocation.se && this.zoneDataManager.currentLocation.se!="")
     {
       opis = opis + " SE |\n";
     }

     if(this.zoneDataManager.currentLocation.s && this.zoneDataManager.currentLocation.s!="")
     {
       opis = opis + " S | \n";
     }

     if(this.zoneDataManager.currentLocation.sw && this.zoneDataManager.currentLocation.sw!="")
     {
       opis = opis + " SW |\n";
     }

     if(this.zoneDataManager.currentLocation.w && this.zoneDataManager.currentLocation.w!="")
     {
       opis = opis + " W |\n";
     }

     if(this.zoneDataManager.currentLocation.nw && this.zoneDataManager.currentLocation.nw!="")
     {
       opis = opis + " NW |\n";
     }

     //console.log(opis)

     let msg = {
      userId: this.timelineService.myName,
      text: opis,
      type: MsgTypes.ROZA_WIATROW,
      payload: null
    }

     this.timelineService.addChatMSG(msg)
     //console.log('show desc');

  }


  updateCounts()
  {
    console.log('updateCounts');
    this.showRoomers();
  }


  onUserEnterRoom(evt)
  {
    console.log('onUserEnterRoom', evt);
    this.showRoomers();
  }

  onUserExitRoom(evt)
  {
    console.log('onUserExitRoom', evt);
    this.showRoomers();
  }

  showRoomers()
  {
    console.log('showRoomers ilu?', this.app.room.getUserList().length);
    this.peopleInTheRoom = [];
    
    for (let index = 0; index < this.app.room.getUserList().length; index++) {
      const element = this.app.room.getUserList()[index];
      if(!element.isItMe)
      {
        console.log('!isItMe ', element);
        this.peopleInTheRoom.push(element)
      }
    }

    //this.app.room.getUserList().length
  }

  async onMsgClick(message)
  {
    
    this.timelineService.showingAccount = this.app.room.getUserByName(message.userId);
    console.log('onMsgClick', this.timelineService.showingAccount);
    if( this.timelineService.showingAccount==undefined) return;

    
    await this.presentAccountModal()
    const { data } = await this.modal.onWillDismiss();
    console.log('?',this.timelineService.showingAccount);
    this.timelineService.showingAccount = null;
    //if(!data) return;
  }

  async openSasiedzi()
  {
    console.log('openSasiedzi');
    if(this.app.room.userCount==2)
    {
      if(!this.app.room.getPlayerList()[0].isItMe)
      {
        this.timelineService.showingAccount = this.app.room.getPlayerList()[0]
      }
      else this.timelineService.showingAccount = this.app.room.getPlayerList()[1]
      console.log('poka PROFIL', this.timelineService.showingAccount);

      await this.presentAccountModal()
      const { data } = await this.modal.onWillDismiss();
      console.log('?',data);
      this.timelineService.showingAccount = null;
      if(!data) return;

    }
    else 
    {
      console.log('poka LISTĘ ZIOMKW');

      await this.presentAccountsModal()
      const { data } = await this.modal.onWillDismiss();
      console.log('czy jest fight?',data);
      if(!data) return;
    }
  }

  onUserCountChange(evtParams)
  {
    console.log("onUserCountChange", evtParams);

    //this.playersInRoom = this.app.room.getPlayerList().length;
    this.showRoomers();// = []

  }

  async showDirections()
  {
    //console.log('ITEMS', this.app.room.getVariable('items').value)
    //this.roomItems = this.room.getVariables();
    //console.log('roomItems', this.roomItems.items);

    //console.log('N', this.app.room.getVariable('goN').value)
    //console.log('Ne', this.app.room.getVariable('goNE').value)
    //console.log('E', this.app.room.getVariable('goE').value)
    //console.log('Se', this.app.room.getVariable('goSE').value)
    //console.log('S', this.app.room.getVariable('goS').value)
    //console.log('Se', this.app.room.getVariable('goSW').value)
    //console.log('W', this.app.room.getVariable('goW').value)
    //console.log('Ne', this.app.room.getVariable('goNW').value)

    let directions = [];
    let directionsLocations = []

    if(this.zoneDataManager.currentLocation.n && this.zoneDataManager.currentLocation.n!="") 
    {
      directions.push(true)
      directionsLocations.push(this.zoneDataManager.currentLocation.n)
    }
    else 
    {
      directions.push(false);
      directionsLocations.push(null)
    }

    if(this.zoneDataManager.currentLocation.ne && this.zoneDataManager.currentLocation.ne!="") 
    {
      directionsLocations.push(this.zoneDataManager.currentLocation.ne)
      directions.push(true)
    }
    else 
    {
      directions.push(false);
      directionsLocations.push(null)
    }

    if(this.zoneDataManager.currentLocation.e && this.zoneDataManager.currentLocation.e!="") 
    {
      directionsLocations.push(this.zoneDataManager.currentLocation.e)
      directions.push(true)
    }
    else 
    {
      directions.push(false);
      directionsLocations.push(null)
    }

    if(this.zoneDataManager.currentLocation.se && this.zoneDataManager.currentLocation.se!="") 
    {
      directionsLocations.push(this.zoneDataManager.currentLocation.se)
      directions.push(true)
    }
    else 
    {
      directions.push(false);
      directionsLocations.push(null)
    }

    if(this.zoneDataManager.currentLocation.s && this.zoneDataManager.currentLocation.s!="") 
    {
      directionsLocations.push(this.zoneDataManager.currentLocation.s)
      directions.push(true)
    }
    else 
    {
     directions.push(false);
      directionsLocations.push(null)
    }

    if(this.zoneDataManager.currentLocation.sw && this.zoneDataManager.currentLocation.sw!="") 
    {
      directionsLocations.push(this.zoneDataManager.currentLocation.sw)
      directions.push(true)
    }
    else 
    {
      directions.push(false);
      directionsLocations.push(null)
    }

    if(this.zoneDataManager.currentLocation.w && this.zoneDataManager.currentLocation.w!="") 
    {
      directionsLocations.push(this.zoneDataManager.currentLocation.w)
      directions.push(true)
    }
    else 
    {
      directions.push(false);
      directionsLocations.push(null)
    }

    if(this.zoneDataManager.currentLocation.nw && this.zoneDataManager.currentLocation.nw!="") 
    {
      directionsLocations.push(this.zoneDataManager.currentLocation.nw)
      directions.push(true)
    }
    else 
    {
      directions.push(false);
      directionsLocations.push(null)
    }
    
   
    console.log('directions', directions);
    console.log('locations', directionsLocations);
    this.timelineService.currentDirections = directions;
    this.timelineService.currentDirectionsLocations = directionsLocations;
    await this.presentModal()
    const { data } = await this.modal.onWillDismiss();
    console.log('?',data.chosenLocation);
    if(!data.chosenLocation || data.chosenLocation==undefined || data.chosenLocation=='x') return;

    console.log('jednak idę');
    /*
    let msg = {
      userId: this.app.myName,
      text: this.app.myName + " rusza ",
      type: MsgTypes.TRAVEL,
      payload: {startLocation: this.timelineService.startMoveFromLocation.globalSFSName, targetLocation: data.chosenLocation, targetDirection: data.chosenDirection, distance: c}
    }
    
    this.timelineService.addChatMSG(msg);
    */
    this.peopleInTheRoom = [];


    var a = this.zoneDataManager.getLocationByID(this.timelineService.startMoveFromLocation.globalSFSName).gpsX - this.zoneDataManager.getLocationByID(data.chosenLocation).gpsX;
    var b = this.zoneDataManager.getLocationByID(this.timelineService.startMoveFromLocation.globalSFSName).gpsY - this.zoneDataManager.getLocationByID(data.chosenLocation).gpsY;

    var c = Math.sqrt( a*a + b*b );


    console.log('distance', c);

    
    this.app.sendMessage(this.timelineService.myName + " kieruje się na " + data.chosenDirection + " w kierunku " + data.chosenLocation)

    await this.presentTravel(data.chosenLocation)
    const { dataTravel } = await this.modal.onWillDismiss();
    console.log('dataTravel', dataTravel);
    //if(dataTravel==undefined) return;
    //console.log('walk to', data.chosenLocation, data.chosenDirection, ' from ', this.timelineService.startMoveFromLocation.globalSFSName);

    //console.log('x from', this.zoneDataManager.getLocationByID(this.timelineService.startMoveFromLocation.globalSFSName).gpsX)
    //console.log('y from', this.zoneDataManager.getLocationByID(this.timelineService.startMoveFromLocation.globalSFSName).gpsY)

    //console.log('to x', this.zoneDataManager.getLocationByID(data.chosenLocation).gpsX)
    //console.log('to y', this.zoneDataManager.getLocationByID(data.chosenLocation).gpsY)

    
    this.app.startWalkingToLocation(data.chosenLocation, data.chosenDirection, this.timelineService.startMoveFromLocation, c);


  }

  onRoomJoin(evtParams)
	{
    console.log("Lok-Room joined: " + evtParams.room.name);
    this.timelineService.messages = [];

    if(this.modal)
    {
      this.modal.dismiss();
    }

    this.showRoomers();
    
    //console.log("locationData",this.zoneDataManager.currentLocation.globalSFSName);
    

    if(evtParams.room.name=='THE_LOBBY' && !this.juzWidzial)
    {
      this.juzWidzial = true;

      let msg = {
        userId: "Kmicic",
        text: "Dzień dobry @" + this.timelineService.myName + ". Zaczynasz na Placu Centralnym, miejscu startowym całego Wszechmiasta.",
        type: MsgTypes.ADMIN,
        payload: this.app.room,
        image: "./assets/avatars/npcs/Kmicic.svg"
      }
  
      this.timelineService.addChatMSG(msg);
  
      let msg2 = {
        userId: "Kmicic",
        text: "Rozejrzyj się tutaj, a potem rusz w dalszą drogę, wedle gustu.",
        type: MsgTypes.ADMIN,
        payload: null,
        image: "./assets/avatars/npcs/Kmicic.svg"
      }
  
      this.timelineService.addChatMSG(msg2);

    }
    
    this.showDescription();
  }

  eventHandler(keyCode) {
    if(keyCode==13)
    {
      this.sendMessage();
    }
  }
  async populate()
  {
    await this.app.awaitFunction(500);
    this.app.populateRoomsList();
    this.app.sfs.addEventListener(SFS2X.SFSEvent.ROOM_JOIN, this.onRoomJoin, this);
    this.app.isSFSconnected = true;
  }
}